import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DefaulterRelaysConfig, Installation, InstallationArea } from 'src/app/interfaces/installation';
import { Terminal, TerminalRelay } from 'src/app/interfaces/terminal';
import { InstallationsAreasService } from 'src/app/services/installations-areas/installations-areas.service';
import { TerminalsService } from 'src/app/services/terminals/terminals.service';

interface AreaTerminal {
  id: string;
  name: string;
  terminals: RelayTerminal[];
}

interface RelayTerminal {
  name: string;
  id: string;
  relays: DefaulterRelay[];
  expanded: boolean;
}

interface DefaulterRelay {
  id: string;
  name: string;
  selected: boolean;
}

@Component({
  selector: 'app-manager-config-relays',
  templateUrl: './manager-config-relays.page.html',
  styleUrls: ['./manager-config-relays.page.scss'],
})
export class ManagerConfigRelaysPage implements OnInit {
  @Input() installation: Installation;
  @Input() defaulter: DefaulterRelaysConfig[];
  installationAreas: InstallationArea[] = [];
  areaTerminals: AreaTerminal[] = [];
  expandFlag = false;

  constructor(
    private areasServ: InstallationsAreasService,
    private terminalsServ: TerminalsService,
    public modalCtrl: ModalController
  ) {}

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.areasServ.getInstallationIDAreas(this.installation.id).subscribe(areaRes => {
      if (areaRes.length > 0) {
        this.installationAreas = areaRes;
        this.installationAreas.forEach(area => {
          const areaTerminals: AreaTerminal = {
            name: area.name,
            id: area.id,
            terminals: [],
          };
          this.terminalsServ.getAreasIDTerminals(area.id).subscribe(terminals => {
            if (terminals.length > 0) {
              areaTerminals.terminals = this.renderTerminals(terminals);
              this.areaTerminals.push(areaTerminals);
            }
            this.defaulter ? this.loadDefaulter() : null;
          });
        });
      }
    });
  }

  loadDefaulter() {
    this.defaulter.forEach(d => {
      this.areaTerminals.forEach(a => {
        a.terminals.map(t => {
          if (t.id === d.terminalId) {
            t.expanded = true;
            t.relays.map(r => {
              d.relays.find(relay => relay === r.id) ? (r.selected = true) : null;
            });
          }
        });
      });
    });
  }

  renderTerminals(terminals: Terminal[]) {
    let res: RelayTerminal[] = [];
    terminals.forEach(terminal => {
      res.push({
        id: terminal.id,
        name: terminal.name,
        relays: this.renderRelays(terminal.config.relays),
        expanded: terminals.length === 1 ? true : false,
      });
    });
    return res;
  }

  renderRelays(relays: TerminalRelay[]) {
    let res: DefaulterRelay[] = [];
    relays.forEach(relay => {
      if (this.validRelayType(relay.type) && relay.active) {
        res.push({
          id: relay.id,
          name: relay.name,
          selected: false,
        });
      }
    });
    return res;
  }

  validRelayType(type: string): boolean {
    return (
      !type ||
      type === 'none' ||
      type === 'none_resident' ||
      type === 'in' ||
      type === 'in_resident' ||
      type === 'out' ||
      type === 'out_resident'
    );
  }

  expandItem(item): void {
    if (this.expandFlag) {
      this.expandFlag = false;
      return;
    }
    item.expanded = !item.expanded;
  }

  getDefaulterRelays(): DefaulterRelaysConfig[] | null {
    const defaulter: DefaulterRelaysConfig[] = [];
    this.areaTerminals.forEach(area => {
      area.terminals.forEach(terminal => {
        terminal.relays.forEach(relay => {
          if (relay.selected) {
            const i = defaulter.findIndex(d => d.terminalId === terminal.id);
            i >= 0
              ? defaulter[i].relays.push(relay.id)
              : defaulter.push({
                  terminalId: terminal.id,
                  relays: [relay.id],
                });
          }
        });
      });
    });
    return defaulter.length > 0 ? defaulter : null;
  }

  saveRelays() {
    this.modalCtrl.dismiss(this.getDefaulterRelays());
  }
}
